import React, { useEffect } from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next';
import leadActionsImp from '../../Actions/leadActions'
import { useNavigate } from "react-router-dom";
import LeadsList from '../../Components/Leads/LeadsList'
import routes from '../../Constants/routes'
import AoCustomerLeadsList from '../../Components/Leads/AoCustomerLeadsList';
import commonActionsImp from '../../Actions/commonActions'
import helpers from "../../Utils/helpers";
import { DefaultCard } from "../../Components/Card/Card";

function CustomerLeadsContainer ({ }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const leads = useSelector(state => state.LeadsReducer.customerLeads);
    const aoLeads = useSelector(state => state.LeadsReducer.aoCustomerLeads);
    const customer = useSelector(state => state.CustomerReducer.customer);
    const dispatch = useDispatch();
    const leadActions = bindActionCreators(leadActionsImp, dispatch);
    const commonActions = bindActionCreators(commonActionsImp, dispatch);

    const vbCustomer = customer?.vbCustomer;

    useEffect(() => {
        if (!!vbCustomer) {
            leadActions.getCustomerLeads(vbCustomer.customerNumber);
            if (helpers.isAoCustomer(vbCustomer)) {
                leadActions.getAoCustomerLeads(vbCustomer.customerNumber);
            }
        }
    }, [])
    
    const sortListByKey = (listName, list) => {
        return key => {
            commonActions.sortListByKey(list, key, listName);
        }
    }

    const moveToDetails = (leadId) => {
        navigate(routes.leadDetails(leadId));
    }

    const moveToDetailsAo = (leadId) => {
        navigate(routes.aoleadDetails(leadId));
    }

    if (!leads && !aoLeads) {
        return null;
    }

    const hasNoData = () => {
        // have neither leads nor aoLeads
        return leads && !leads.length && aoLeads && !aoLeads.length;
    }
    
    return <DefaultCard title={t('customernavigation.leads')} hasNoData={hasNoData()}>
        {leads && leads.length > 0 && <LeadsList leads={leads} hideCustomer={true} useGoBack={true} moveToDetails={moveToDetails} sortListByKey={sortListByKey("customerLeads", leads)} />}
        {aoLeads && aoLeads.length > 0 && <AoCustomerLeadsList leads={aoLeads} hideCustomer={true} useGoBack={true} moveToDetails={moveToDetailsAo} />}
    </DefaultCard>
}
export default CustomerLeadsContainer;